import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { MarketdateStatus } from './marketdate-status.model';
import { MarketdateStatusService } from './marketdate-status.service';

@Component({
    selector: 'jhi-marketdate-status-detail',
    templateUrl: './marketdate-status-detail.component.html'
})
export class MarketdateStatusDetailComponent implements OnInit, OnDestroy {

    marketdateStatus: MarketdateStatus;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdateStatusService: MarketdateStatusService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdateStatuses();
    }

    load(id) {
        this.marketdateStatusService.find(id).subscribe((marketdateStatus) => {
            this.marketdateStatus = marketdateStatus;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdateStatuses() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateStatusListModification', (response) => this.load(this.marketdateStatus.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status-detail.component.ts